import { useContext, useEffect, useMemo, useState } from "react"
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { useLayout } from "../../layout/useLayout";

export const useBroadcast = () => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [visible, setVisible] = useState(false);
    const [notificationData, setNotificationData] = useState({
        startDate: new Date(),
        timeSelected: "",
        interval: 0,
        hoursInterval: 0,
        dates: [],
        selectedMonth: [],
        selectedWeek: [],
        endDate: new Date(),
        oneTimeDate: new Date(),
        freqSelected: "DAI",
        notifiTitle: "",
        notifiMessage: "",
        notifiTypeSelected: {},
        notifiId: 0,
        scheduleId: 0
    })
    const [notificationList, setNotificationList] = useState([]);
    const [broadcastTitle, setBroadcastTitle] = useState("Schedule new Notification");
    const [showNewNotifi, setShowNewNotify] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteIconId, setDeleteIconId] = useState(null);
    const [viewList, setViewList] = useState(true);
    const [weekDays] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);
    const [months] = useState(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]);
    const [loader, setLoader] = useState(false)
    const { notifiTypes } = useLayout();
    useEffect(() => {
        getAllNotification();
    }, [])

    useEffect(() => {
        if (notificationData.notifiId == 0) {
            setNotificationData((prev) => ({ ...prev, dates: [], selectedWeek: [], selectedMonth: [], oneTimeDate: new Date(), hoursInterval: 0 }));
        }
    }, [notificationData.freqSelected])

    useEffect(() => {
        if (notificationData.freqSelected === "ONE") {
            setNotificationData((prev) => ({ ...prev, startDate: notificationData.oneTimeDate, endDate: notificationData.oneTimeDate }));
        }
    }, [notificationData.oneTimeDate])

    // create new notification
    const handleCreateNew = () => {
        if (notificationData.notifiId == 0) {
            setShowNewNotify(!showNewNotifi);
        } else {
            setShowNewNotify(true);
        }
        setBroadcastTitle("Schedule new Notification");
        setNotificationData((prev) => ({ ...prev, freqSelected: "DAI", notifiId: 0, scheduleId: 0 }))
        handleReset();
    }

    const handleAddWeek = (week) => {
        if (!_.includes(notificationData.selectedWeek, week)) {
            let selectedWeekData = notificationData.selectedWeek;
            selectedWeekData.push(week);
            setNotificationData((prev) => ({ ...prev, selectedWeek: selectedWeekData }));
        } else {
            setNotificationData((prev) => ({ ...prev, selectedWeek: notificationData.selectedWeek.filter((item) => item != week) }));
        }
    }

    const handleAddMonth = (month) => {
        if (!_.includes(notificationData.selectedMonth, month)) {
            let selectedMonthData = notificationData.selectedMonth;
            selectedMonthData.push(month);
            setNotificationData((prev) => ({ ...prev, selectedMonth: selectedMonthData }));
        } else {
            setNotificationData((prev) => ({ ...prev, selectedMonth: notificationData.selectedMonth?.filter((item) => item != month) }))
        }
    }

    // reset notification values
    const handleReset = () => {
        setNotificationData((prev) => ({ ...prev, startDate: new Date(), timeSelected: "", interval: 0, dates: [], selectedWeek: [], selectedMonth: [], endDate: new Date(), oneTimeDate: new Date(), notifiTitle: "", notifiMessage: "", notifiTypeSelected: {}, hoursInterval: 0 }))
    }

    // save new and edited notification
    const handleSave = async () => {
        try {
            if (notificationData?.timeSelected?.length === 0 || notificationData?.notifiTitle?.length === 0 || notificationData?.notifiMessage?.length === 0 || _.isEmpty(notificationData?.notifiTypeSelected)) {
                showInfo("info", "Fields should not be empty");
                return;
            }

            let daysOfMonth = [];
            notificationData?.dates?.forEach((date, index) => {
                daysOfMonth[index] = date.getDate();
            })

            let monthOfYear = [];
            notificationData?.selectedMonth?.forEach((month, index) => {
                const idx = _.indexOf(months, month);
                monthOfYear[index] = idx + 1;
            })

            let start = notificationData?.startDate?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-");

            const payload = {
                "notification_id": notificationData?.notifiId,
                "notification_type_id": notificationData?.notifiTypeSelected.notification_type_id,
                "schedule_id": notificationData?.scheduleId,
                "notification_title": notificationData?.notifiTitle,
                "notification_message": notificationData?.notifiMessage,
                "is_active": true,
                "notification_type_name": notificationData?.notifiTypeSelected.notification_type_name,
                "recurrence_pattern": notificationData?.freqSelected,
                "recurrence_interval": notificationData?.interval,
                "recurrence_interval_hour": notificationData?.hoursInterval,
                "days_of_week": notificationData?.selectedWeek.toString(),
                "days_of_month": daysOfMonth.toString(),
                "month_of_year": monthOfYear.toString(),
                "schedule_startdate": notificationData?.startDate?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-"),
                "schedule_enddate": notificationData?.endDate?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-"),
                "schedule_time": notificationData?.timeSelected
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTBROADCASTNOTIFICATION"), payload)

            if (res) {
                showSuccess("success", res?.body?.message);
                handleReset();
                setNotificationData((prev) => ({ ...prev, freqSelected: "DAI" }))
                setBroadcastTitle("Schedule new Notification");
                getAllNotification();
                setShowNewNotify(false);
            }
        } catch (error) {
            console.error(error);
            showError("error", error?.response?.data?.errorMessage);
        }
    }

    // get notification list
    const getAllNotification = async () => {
        setLoader(true)
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETALLBROADCASTNOTIFICATION"), {});
            if (res) {
                let list = res?.body?.data?.notification_list;
                list = list.filter(item => { return item.notification_title != null });
                list.sort((a, b) => {
                    const dateA = new Date(a.generate_datetime);
                    const dateB = new Date(b.generate_datetime);
                  
                    return dateB - dateA;
                  });
                setNotificationList(list);
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error);
            showError("error", error?.response?.data?.errorMessage);
        }
    }

    // set individual notification data to edit
    const handleSelectNotification = (data) => {
        setShowNewNotify(true);
        setBroadcastTitle(data.notification_title);
        let dateArr = [];
        if (data.days_of_month?.length !== 0 && data.days_of_month != null) {
            data.days_of_month?.split(",")?.forEach((day) => {
                const mon = new Date().getMonth();
                const yea = new Date().getFullYear();
                const fullDate = `${yea}-${mon}-${day}`;
                dateArr.push(new Date(fullDate));
            })
        }

        let monthArr = [];
        if (data.month_of_year?.length !== 0 && data.month_of_year != null) {
            data.month_of_year?.split(",")?.forEach((mon) => {
                monthArr.push(months[mon - 1]);
            })
        }

        setNotificationData((prev) => ({
            ...prev,
            startDate: new Date(data.schedule_startdate),
            notifiId: data.notification_id,
            scheduleId: data.schedule_id,
            timeSelected: `${data.schedule_time?.split(":")?.[0]}:${data.schedule_time?.split(":")?.[1]}`,
            interval: data.recurrence_interval,
            dates: dateArr,
            selectedMonth: monthArr,
            selectedWeek: data.days_of_week != null ? data.days_of_week.split(",") : [],
            endDate: new Date(data.schedule_enddate),
            oneTimeDate: new Date(data.schedule_startdate),
            notifiTitle: data.notification_title,
            notifiMessage: data.notification_message,
            notifiTypeSelected: _.findWhere(notifiTypes, { notification_type_id: data.notification_type_id }),
            hoursInterval: data.recurrence_interval_hour != null ? data.recurrence_interval_hour : 0,
            freqSelected: data.recurrence_pattern
        }));
    }

    // delete notification
    const handleDelete = async (id) => {
        try {
            const payload = {
                "schedule_id": id
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEBROADCASTNOTIFICATION"), payload)
            if (res) {
                showSuccess("success", "Broadcast deleted successfully");
                getAllNotification();
                setShowNewNotify(false);
            }
        } catch (error) {
            console.error(error);
            showError("error", error?.response?.data?.errorMessage);
        }
    }

    return useMemo(() => ({
        viewList, setViewList, loader, handleCreateNew, notificationList, notificationData, setNotificationData, handleSelectNotification, showDelete, setShowDelete, deleteIconId, setDeleteIconId, handleDelete, showNewNotifi, broadcastTitle, weekDays, handleAddWeek, handleAddMonth, months, notifiTypes, handleReset, handleSave, visible, setVisible
    }), [viewList, setViewList, loader, handleCreateNew, notificationList, notificationData, setNotificationData, handleSelectNotification, showDelete, setShowDelete, deleteIconId, setDeleteIconId, handleDelete, showNewNotifi, broadcastTitle, weekDays, handleAddWeek, handleAddMonth, months, notifiTypes, handleReset, handleSave, visible, setVisible])
}